<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="21" height="21" rx="4.5" stroke="#213E7A" />
    <path
      d="M15.5833 11C15.5833 10.8784 15.6316 10.7619 15.7176 10.6759C15.8035 10.59 15.9201 10.5417 16.0417 10.5417C16.1632 10.5417 16.2798 10.59 16.3658 10.6759C16.4517 10.7619 16.5 10.8784 16.5 11V16.0417C16.5 16.1632 16.4517 16.2798 16.3658 16.3658C16.2798 16.4517 16.1632 16.5 16.0417 16.5H5.95833C5.83678 16.5 5.7202 16.4517 5.63424 16.3658C5.54829 16.2798 5.5 16.1632 5.5 16.0417V5.95833C5.5 5.83678 5.54829 5.7202 5.63424 5.63424C5.7202 5.54829 5.83678 5.5 5.95833 5.5H11C11.1216 5.5 11.2381 5.54829 11.3241 5.63424C11.41 5.7202 11.4583 5.83678 11.4583 5.95833C11.4583 6.07989 11.41 6.19647 11.3241 6.28242C11.2381 6.36838 11.1216 6.41667 11 6.41667H6.41667V15.5833H15.5833V11Z"
      fill="#213E7A"
    />
    <path
      d="M10.0471 11.9517L10.8034 11.8435L15.4491 7.19875C15.4928 7.15647 15.5278 7.10589 15.5518 7.04997C15.5758 6.99406 15.5884 6.93391 15.589 6.87306C15.5895 6.8122 15.5779 6.75185 15.5549 6.69552C15.5318 6.63919 15.4978 6.58802 15.4547 6.54498C15.4117 6.50195 15.3605 6.46792 15.3042 6.44487C15.2479 6.42183 15.1875 6.41023 15.1267 6.41076C15.0658 6.41129 15.0057 6.42393 14.9498 6.44795C14.8938 6.47197 14.8433 6.50689 14.801 6.55066L10.1544 11.1954L10.0462 11.9517H10.0471ZM16.0971 5.90166C16.2249 6.02936 16.3263 6.18097 16.3954 6.34785C16.4646 6.51473 16.5002 6.69361 16.5002 6.87425C16.5002 7.05489 16.4646 7.23376 16.3954 7.40064C16.3263 7.56752 16.2249 7.71914 16.0971 7.84683L11.3442 12.5997C11.2741 12.6701 11.1831 12.7158 11.0848 12.7299L9.57232 12.9462C9.50183 12.9564 9.42995 12.9499 9.36239 12.9274C9.29482 12.9049 9.23343 12.867 9.18307 12.8167C9.13272 12.7663 9.09479 12.7049 9.07229 12.6373C9.0498 12.5698 9.04336 12.4979 9.05348 12.4274L9.26982 10.9149C9.2837 10.8167 9.32906 10.7257 9.39907 10.6555L14.1529 5.90258C14.4107 5.64481 14.7604 5.5 15.125 5.5C15.4896 5.5 15.8393 5.64481 16.0971 5.90258V5.90166Z"
      fill="#213E7A"
    />
  </svg>
</template>

<script>
export default {
  name: "IconEditUser",
};
</script>

<style></style>
